import { FormattedMessage } from "react-intl";

import { language, languageDefault } from "../../services/utils/Language";

import "./styles.scss";

const TermAndConditionsPayment = () => {
    return (
        <span className="text-term-conditions">
            <FormattedMessage id={language.ended_acept_us} defaultMessage={languageDefault.ended_acept_us} />{" "}
            <a
                className="link-green"
                href="http://www.paguelofacil.com/terminos-y-condiciones/"
                target="_blank"
                without
                rel="noreferrer"
            >
                <FormattedMessage id={language.terms_conditions} defaultMessage={languageDefault.terms_conditions} />
            </a>{" "}
            <FormattedMessage
                id={language.show_information_given}
                defaultMessage={languageDefault.show_information_given}
            />
        </span>
    );
};

export default TermAndConditionsPayment;
